import React from "react";
import { Deck, Slide } from "spectacle";
import createTheme from "spectacle/lib/themes/default";
import createHashHistory from 'history/createHashHistory'

import Hello from './slides/Hello';
import AboutAltola from './slides/AboutAltola';
import WhoWeAre from "./slides/WhoWeAre";
import KnownUnknowns from "./slides/KnownUnknowns";
import TimeAllocationSlide from "./slides/TimeAllocationSlide";
import Contact from "./slides/Contact";

import bgImage from './images/bg.jpg';
import sfImage from "./images/sf.jpg";
import contactImage from './images/contact.jpg';

import TimeAllocationSlideContent from './content/components/time-allocation';
import MissedOpportunity from "./slides/MissedOpportunity";
import OurSolutionOptimization from './slides/OurSolutionOptimization';
import OurSolutionBenefits from "./slides/OurSolutionBenefits";
import OurSolutionConnected from "./slides/OurSolutionConnected";
import OurSolutionHowItWorks from "./slides/OurSolutionHowItWorks";
import OurSolutionWhenWhatHow from "./slides/OurSolutionWhenWhatHow";
import OurSolutionMain from "./slides/OurSolutionMain";


const theme = createTheme({
  primary: "#F1FAEE",
  secondary: "#1D3557",
  tertiary: "#457B9D",
  quarternary: "#E63946",
  fifth: "#A8DADC",
  white: "#fff"
},
  {
    primary: { name: "Open Sans", googleFont: true, styles: ["400", "700i"] },
    secondary: "Helvetica"
  });

// TODO: refactor Partner and Customer deck so the history logic will be consolidated
const history = createHashHistory({
  basename: "",
  hashType: "slash",
});
history.listen((location, action) => {
  if (window.gtag) {
    const event = {
      'page_title': location.pathname.replace('/', ''),
      'page_path': `${window.location.pathname}${location.pathname}`
    };
    window.gtag('config', 'UA-117495070-2', event);
  }
});

export default class CustomerDeck extends React.Component {
  render() {
    return (
      <Deck history={history} transition={["zoom", "slide"]} transitionDuration={500} theme={theme} controls={true}>
        <Slide id="hello" transition={["zoom"]} bgImage={bgImage}>
          <Hello content={{ title: "Welcome Disrupt SF", subtitle: "AI POWERED SLIDES" }} />
        </Slide>
        <Slide id="about" transition={["zoom", "slide"]} bgImage={sfImage} bgDarken={0.7}>
          <AboutAltola />
        </Slide>
        <Slide id="who-we-are" transition={["zoom", "slide"]} bgColor="white">
          <WhoWeAre />
        </Slide>
        <Slide id="time-allocation" transition={["zoom", "slide"]} bgImage={bgImage}>
          <TimeAllocationSlide content={TimeAllocationSlideContent} />
        </Slide>
        <Slide id="known-unknowns" transition={["zoom", "slide"]} bgImage={bgImage}>
          <KnownUnknowns />
        </Slide>
        <Slide id="missed-opportunity" transition={["zoom", "slide"]} bgImage={bgImage}>
          <MissedOpportunity />
        </Slide>
        <Slide id="our-solution-main" transition={["zoom", "slide"]} bgImage={bgImage}>
          <OurSolutionMain />
        </Slide>
        <Slide id="our-solution-optimization" transition={["zoom", "slide"]} bgImage={bgImage}>
          <OurSolutionOptimization />
        </Slide>
        <Slide id="our-solution-connected" transition={["zoom", "slide"]} bgImage={bgImage}>
          <OurSolutionConnected />
        </Slide>
        <Slide id="our-solution-benefits" transition={["zoom", "slide"]} bgImage={bgImage}>
          <OurSolutionBenefits />
        </Slide>
        <Slide id="our-solution-how-it-works" transition={["zoom", "slide"]} bgImage={bgImage}>
          <OurSolutionHowItWorks />
        </Slide>
        <Slide id="our-solution-when-what-how" transition={["zoom", "slide"]} bgImage={bgImage}>
          <OurSolutionWhenWhatHow />
        </Slide>
        <Slide id="contact" transition={["zoom", "slide"]} bgImage={contactImage} bgDarken={0.75}>
          <Contact />
        </Slide>
      </Deck>
    );
  }
}



// WEBPACK FOOTER //
// ./src/CustomerDeck.js